import Common from '../../Common';

export interface CompanyRetainmentItem {
	id: id
	pbx_company_id: id
	retainment_type_id: id
	value: number
	last_executed: string
}

export interface CompanyRetainmentType {
	id: id
	name: string
	info: string
	max: string
}

export type CompanyRetainmentCreateBody = {
	retainment_type_id: id
	value: string
}

export type CompanyRetainmentUpdateBody = {
	value: string
}

const Retainment = class extends Common {
	browse = (companyId: id): CustomResponse<CompanyRetainmentItem[]> =>
		this.get(`/company/${companyId}/retainment`)

	create = (companyId: id, body: CompanyRetainmentCreateBody) =>
		this.post(`/company/${companyId}/retainment`, body)

	update = (companyId: id, id: id, body: CompanyRetainmentUpdateBody) =>
		this.patch(`/company/${companyId}/retainment/${id}`, body)

	types = (companyId: id): CustomResponse<CompanyRetainmentType[]> =>
		this.get(`/company/${companyId}/retainment/types`)
}

export default Retainment
